import * as React from 'react';
import { Dispatch, connect } from "react-redux";
import { IApplicationState, AppActionCreators, IWaitListAllocationResponse, CenterActionCreators } from "@nkr/store/index";
import { IWaitlistAllocationConfig, IBaseResponse } from "@nkr/models/index";
import { IWaitlistAllocationData } from './waitlist-allocation-data';
import { IWaitlistAllocationConfigRequest } from '@nkr/models/waitlist-allocation-config-request';
import WaitlistAllocation from '../waitlist-allocation/waitlist-allocation';
import { toast } from 'react-toastify';

interface IOwnProps {
    centerId: number
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getWaitListConfig: (id: number) => Promise<IWaitListAllocationResponse>,
    saveWaitListConfig: (centerId: number, data: IWaitlistAllocationConfigRequest) => Promise<IBaseResponse>
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

interface IState {
    centerId: number,
    waitlistconfig: IWaitlistAllocationConfig
}

class WaitListConfig extends React.Component<TProps, IState>{
    readonly state: IState = {
        centerId: 0,
        waitlistconfig: null
    }

    componentDidMount() {
        this.getWaitListData();
    }

    handleWaitConfigSave = (centerId: number, data: IWaitlistAllocationData) => {
        let request: IWaitlistAllocationConfigRequest = {
            ...data,
            centerId: this.state.centerId
        };

        this.props.showLoading("Saving Wait List Config, one moment please...").then(() => {
            //We need to modify this to use the passed in ID later.
            this.props.saveWaitListConfig(this.props.centerId, request).then(response => {
                if (response.data.success) {
                    toast.success("WaitList Config saved successfully");
                }

                this.props.hideLoading();
            });
        });
    }

    getWaitListData = () => {
        this.props.showLoading("Loading Waitlist Allocation Config, one moment please...").then(() => {
            this.props.getWaitListConfig(this.props.centerId).then(response => {

                this.setState({
                    waitlistconfig: response.data.results
                });

                this.props.hideLoading();
            });
        });
    }

    render = () => {
        return (
            <div>
                {this.state.waitlistconfig != null && (
                    <WaitlistAllocation
                        data={this.state.waitlistconfig}
                        onSave={this.handleWaitConfigSave}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return null;
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return ({
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getWaitListConfig: (id) => {
            return dispatch(CenterActionCreators.getWaitListConfig(id));
        },
        saveWaitListConfig: (centerId, data) => {
            return dispatch(CenterActionCreators.saveWaitListConfig(centerId, data));
        }
    });
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(WaitListConfig);

